import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class TableSwitch extends Component {

  configure() {
    return super.configure();
  }

  initialize() {

    this.elements = $('.is-prices-switcher');

    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    this.elements.on('click', (event) => {
      return this.onClick(event);
    });
  }

  onClick(event) {

    let element = $(event.currentTarget),
        priceTable = element
          .closest('form')
          .find('.is-price-list-table');

    event.preventDefault();

    if (priceTable.hasClass('is-all')) {
      priceTable.removeClass('is-all');
      element.text(this.App.Language.get('price-manager.form.show_inactive'));
    } else {
      priceTable.addClass('is-all');
      element.text(this.App.Language.get('price-manager.form.hide_inactive'));
    }

  }

}